






import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue")
    }
})
export default class TitledComponent extends Vue {
    @Prop() model: any;

    getLevel(){
        var level = -1;
        var parent : any = this;
        while(parent){
            if(parent.model){
                if(parent.model.type == "TitledComponent"){
                    level++;
                }
            }
            parent = parent.$parent;
        }
        return level;
    }

    getTagForLevel(){
        return "h" + (2 + this.getLevel());
    }
}
